// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  height: 50px;
  padding: 2%;
}

h1, p {
  margin: 0;
  padding: 0;
}

nav {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/site/site.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;AACJ","sourcesContent":["header{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: start;\r\n    align-items: center;\r\n    height: 50px;\r\n    padding: 2%;\r\n}\r\n\r\nh1 , p{\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nnav{\r\n    display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
